import { Controller } from 'stimulus';

// Got it on a What's new card or a screen callout (release_notes/_card,
// _callout). Removes the element at once and records the dismissal in the
// background; the server stops rendering it from the next page on.
export default class extends Controller {
  dismiss(event) {
    event.preventDefault();
    const url = event.currentTarget.dataset.url;
    const meta = document.querySelector('meta[name="csrf-token"]');
    if (url) {
      fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: { 'X-CSRF-Token': meta ? meta.content : '', Accept: 'application/json' }
      }).catch(() => {});
    }
    this.element.remove();
  }
}
